import React from 'react';
import style from './header.module.css';
import HeaderMenu from '../headerMenu/headerMenu';
import Breadcrumbs from '../breadcrumbs/breadcrumbs';
import SeasonSelector from "../seasonSelector/seasonSelector";

interface HeaderProps {
	title: string;
	menu?: any;
	currentSeason?: string;
	seasons?: any;
}

const Header: React.FC<HeaderProps> = ({ title, menu, currentSeason, seasons }) => {  // Деструктуризация пропсов здесь
	return (
		<header className={style.header}>
			<div className={style.header__content}>
				<Breadcrumbs />
				<section>
					<h1 className={style.header__h1}>{title}</h1>
					{ currentSeason &&
						<SeasonSelector currentSeason={currentSeason} seasons={seasons}/>
					}
				</section>
				<HeaderMenu menu={menu} />
			</div>
		</header>
	);
};

export default Header;
